import React from "react";
import Body from "./Body";

const Charity = () => {
  const _this = {};
  return <Body {..._this} />;
};

export default Charity;
